/**
 * Errors that mean a queued mutation can never succeed as written — drop it from the offline
 * queue rather than retry forever. Shared between apps/app's and apps/painter-view's Apollo
 * clients so adding a new ignorable error only needs to happen in one place.
 */
export const ignoredOfflineErrors = [
  'Failed to fetch',
  'Save Rejected:',
  'Response not successful:',
  'Rev Mismatch',
  'document without _rev',
  // saveQuote used to swallow these and answer `saveQuote: null`, so a queued save was dropped
  // with no `errors` on the response. It throws them now (#22948), and onComplete keeps any
  // unlisted error in the queue forever, re-firing "Unable to send persisted mutation" on every
  // drain. Both messages come from apps/api/src/graphql/modules/quotes/saveQuote.ts.
  // The QUOTE_SAVE_FAILED wrapper.
  'Unable to save\\. Please try again\\.'
]
